import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { feedbackQueryKeys, resolveFeedback } from '../api/feedback.api';
import type { ResolveFeedbackPayload } from '../types/feedback.types';

interface ResolveArgs {
  id: number;
  payload: ResolveFeedbackPayload;
}

export function useResolveFeedback(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: ResolveArgs) => resolveFeedback(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: feedbackQueryKeys.lists() });
      toast.success('Feedback resolved');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to resolve feedback');
    },
  });
}
